import { render } from "./DamageList.vue?vue&type=template&id=251a0384"
import script from "./DamageList.vue?vue&type=script&lang=js"
export * from "./DamageList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__